export default function libelle(type) {
    if ("INSCRITE" === type) {
        return "Inscrite";
    } else if ("REJETEE" === type) {
        return "Rejetée";
    } else if ("EN_COURS" === type) {
        return "En cours";
    }
    return null;
}

export function etatRequetes() {
    return [
        "EN_COURS",
        "INSCRITE",
        "REJETEE",
    ]
}

export function etatRequeteSelectItems() {
    return etatRequetes().map(value => ({ value, text: libelle(value) }));
}
